import dayjs from 'dayjs';

import type {SubgoalApiModel} from '../../../api/goal';
import type {Nullable} from '../../utility-types';

import {datetimeObjToISOString} from '../../datetime';

export const getSubgoalDurationString = (
  subgoal?: Nullable<Partial<SubgoalApiModel>>,
) => {
  if (!subgoal || !subgoal.start_date) {
    return '';
  }

  const startDate = dayjs(datetimeObjToISOString(subgoal.start_date));
  const endDate = dayjs(datetimeObjToISOString(subgoal.end_date));

  return `${startDate.format('ll').replace(/\s/g, '\u00A0')} — ${endDate
    .format('ll')
    .replace(/\s/g, '\u00A0')}`;
};
